import {useDebugValue, useEffect} from 'react';

import {useInitialization} from '../../../hooks/useInitialization';

import {getObjectValues} from '../../../utils/object';

function useGuestsActions(data) {
    const {
        guestsEvents: {
            onSettingsChange,
            onCurrentValuesChange,
            onLatestValuesChange
        },
        initialGuestsSettings,
        changeGuestsSettings,
        initialGuestsValues,
        currentGuestsValues,
        latestGuestsValues,
        setCurrentGuestsValuesLatest,
        setLatestGuestsValues,
        setAllGuestsValuesDefault,
        setAllGuestsValuesInitial
    } = data;

    const {
        isInitialized
    } = useInitialization();

    function setSettings(nextSettings) {
        changeGuestsSettings(nextSettings);

        onSettingsChange(nextSettings);
    }

    function setSettingsInitial() {
        setSettings(initialGuestsSettings);
    }

    function setIsOpen(isOpen) {
        setSettings({
            isOpen
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setSettingsInitial, [...getObjectValues(initialGuestsSettings)]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setAllGuestsValuesInitial, [...getObjectValues(initialGuestsValues)]);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerCurrentValuesChange() {
        if (isInitialized) {
            onCurrentValuesChange(currentGuestsValues);
        }
    }, [...getObjectValues(currentGuestsValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerLatestValuesChange() {
        if (isInitialized) {
            onLatestValuesChange(latestGuestsValues);
        }
    }, [...getObjectValues(latestGuestsValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */

    const result = {
        setIsOpen,
        setCurrentGuestsValuesLatest,
        setLatestGuestsValues,
        setAllGuestsValuesDefault
    };

    useDebugValue(result);

    return result;
}

export {useGuestsActions};
